export const acquiredValues = ["POA", "IHA", "IHAw", "PIHAw"];

export const acquiredPayloadFilters = {
  inHouse: ["IHA", "IHAw"],
  externally: ["POA", "PIHAw"]
};
